<template>
  <div id="company-display-container" class="d-flex justify-content-center">
    <div v-if="selectedCompany" id="cd-content" class="d-flex flex-column">
      <BModal v-if="show !== undefined" :visible="show" :title="selectedCompany.name" hide-footer size="lg" @hide="$emit('hide')">
        <Banner v-if="selectedTheme && !hideBanner" :company="selectedCompany" :theme="selectedTheme" />
        <Overview :company="selectedCompany" />
        <Products :products="selectedCompany.products" />
        <div class="row">
          <Brands v-if="selectedCompany.brands && selectedCompany.brands.length" :brands="selectedCompany.brands" />
          <Awards v-if="selectedCompany.awards && selectedCompany.awards.length" :awards="selectedCompany.awards" />
        </div>
        <Operations :company-name="selectedCompany.name" :operations="selectableOperations" />
      </BModal>

      <div v-else id="cd-outline">
        <Banner v-if="selectedTheme && !hideBanner" :company="selectedCompany" :theme="selectedTheme" />
        <Overview :company="selectedCompany" />
        <Products :products="selectedCompany.products" />
        <div class="row d-flex flex-wrap">
          <Brands v-if="selectedCompany.brands && selectedCompany.brands.length" :brands="selectedCompany.brands" />
          <Awards v-if="selectedCompany.awards && selectedCompany.awards.length" :awards="selectedCompany.awards" />
        </div>
        <Operations class="mt-3" :company-name="selectedCompany.name" :operations="selectableOperations" />
      </div>
    </div>
    <div v-else>
      <Loading />
    </div>
  </div>
</template>

<script>
import Overview from "./components/Overview.vue";
import Products from "./components/Products.vue";
import Brands from "./components/Brands.vue";
import Awards from "./components/Awards.vue";
import Operations from "./components/Operations.vue";
import Banner from "./components/Banner.vue";

import * as api from "@/services/api";

export default {
  components: {
    Overview,
    Products,
    Brands,
    Awards,
    Operations,
    Banner,
  },
  props: {
    companyId: { type: Number },
    theme: { type: Object },
    company: { type: Object },
    hideBanner: { type: Boolean, default: false },
    show: { type: Boolean, default: undefined },
  },
  emits: ["hide"],
  data() {
    return {
      selectedTheme: undefined,
      selectedCompany: this.company,
    };
  },
  computed: {
    selectableOperations() {
      if (this.selectedCompany && this.selectedCompany.operations) {
        return this.selectedCompany.operations.filter((op) => !op.hide_from_display_page);
      }
      return [];
    },
  },
  watch: {
    company(newCompanyValue, oldCompanyValue) {
      if (newCompanyValue && newCompanyValue.hasOwnProperty("id")) {
        this.selectedCompany = newCompanyValue;
      }
    },
  },
  mounted() {
    this.setSelectedTheme();
    this.setSelectedCompany();
  },
  methods: {
    setSelectedCompany() {
      if (!this.selectedCompany && this.companyId) {
        api.get(`/company/${this.companyId}`).then((response) => {
          const { status, data } = response;
          if (status === 200 && data) {
            this.selectedCompany = data.data;
          }
        });
      }
    },
    setSelectedTheme() {
      const getTheme = (companyId) => {
        api.get(`theme/${companyId}/menu`).then((response) => {
          const { status, data } = response;
          if (status === 200 && data) {
            this.selectedTheme = data;
          }
        });
      };
      if (!this.theme && this.companyId) {
        getTheme(this.companyId);
      } else if (!this.theme && this.company) {
        getTheme(this.company.id);
      } else if (this.theme) {
        this.selectedTheme = this.theme;
      } else {
        // ? is there a global error handler we can use?

        console.error("the prop 'companyId' or 'theme' are required for 'CompanyDisplay' component!");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#company-display-container {
  #cd-content {
    max-width: 50rem;
    width: 50rem;
    #cd-outline {
      border: 1px solid slategray;
      border-radius: 1rem;
      padding: 1rem;
    }
  }
}
</style>
